import _ from 'lodash';
import update from 'immutability-helper';
import actionTypes from '../actions/action_types';

const initialState = {
  user: null,
  teams: null,
};

function updateRoomBlacklist(state, teamId, roomId, set) {
  const teams = state.teams;
  const teamIndex = teams.findIndex(team => team.id === teamId);
  const roomIndex = teams[teamIndex].rooms.findIndex(room => room.id === roomId);

  return update(state, {
    teams: { [teamIndex]: { rooms: { [roomIndex]: { blacklisted: { $set: set } } } } },
  });
}

export default function reducer(state = initialState, action) {
  let result;

  switch (action.type) {
    case actionTypes.WEBEX_USER_LOADED: {
      result = _.assign({}, state, {
        user: action.payload.user,
      });
      break;
    }

    case actionTypes.WEBEX_CHANNELS_LOADED: {
      result = _.assign({}, state, {
        teams: action.payload.teams,
      });
      break;
    }

    case actionTypes.WEBEX_CHANNELS_UPDATED: {
      result = _.assign({}, state, {
        teams: action.payload.teams,
      });
      break;
    }

    case actionTypes.WEBEX_CHANNEL_ADDED_TO_BLACKLIST: {
      const roomId = action.payload.channelId;
      const teamId = action.payload.teamId;

      result = updateRoomBlacklist(state, teamId, roomId, true);
      break;
    }

    case actionTypes.WEBEX_CHANNEL_REMOVED_FROM_BLACKLIST: {
      const roomId = action.payload.channelId;
      const teamId = action.payload.teamId;

      result = updateRoomBlacklist(state, teamId, roomId, false);
      break;
    }

    default: {
      result = _.assign({}, state);
    }

  }

  return result;
}



// WEBPACK FOOTER //
// ./src/reducers/webex.js